import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox, DatePicker, FloatButton, Select } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { toast, ToastContainer } from 'react-toastify';
import { Container, ModalBody } from 'react-bootstrap';
import EditBooking from './EditBooking';
// import { FcClearFilters } from "react-icons/fc";
import { IoMdCloseCircle } from "react-icons/io";
import TerminalLoader from './TerminalLoader';
import ViewBooking from './ViewBooking';

import { FaMoon } from 'react-icons/fa';



const Bookings = ({ booking, type, userType, userGroups }) => {
    const [isDeleteBookingModalVisible, setIsDeleteBookingModalVisible] = useState(false);
    const [bookingToDelete, setBookingToDelete] = useState(null);
    const [bookingToEdit, setBookingToEdit] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isEditBookingModalVisible, setIsEditBookingModalVisible] = useState(false);

    const [bookingToView, setBookingToView] = useState(null);
    const [isViewBookingModalVisible, setIsViewBookingModalVisible] = useState(false);

    const [forceDeleteText, setForceDeleteText] = useState('');

    const [locationsData, setLocationsData] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isRescheduling, setIsRescheduling] = useState(false)
    const [bookings, setBookings] = useState([]);
    const [aggregatedBookingStats, setAggregatedBookingStats] = useState([]);
    const [authorizedPermissions, setAuthorizedPermissions] = useState({});


    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    const [filterEmail, setFilterEmail] = useState('');
    const [filterLocation, setFilterLocation] = useState(null);
    const [filterFromDate, setFilterFromDate] = useState(null);
    const [filterToDate, setFilterToDate] = useState(null);
    const [reschedulingData, setReschedulingData] = useState({});
    const [miscFeesValue, setMiscFeesValue] = useState(null)
    const [bookingStatus, setBookingStatus] = useState(null)
    const [isRefunded, setIsRefunded] = useState(false);
    const [timezone, setTimezone] = useState('localTimezone')

    useEffect(() => {
        console.log("Booking Pagination", pagination.current, pagination.pageSize, false)
        getBookings(pagination.current, pagination.pageSize, false);
    }, [bookingToView])

    useEffect(() => {

        getBookings();
        getLocationsData();
        handleAdminAuthorizedPermissions();

    }, []);

    const handleAdminAuthorizedPermissions = () => {
        try {
            if (userType === 'Breathe-Admin') {
                const allAuthorizedPermissions = {};
                userGroups.forEach((userGroup) => Object.assign(allAuthorizedPermissions, JSON.parse(userGroup.permissions)));
                setAuthorizedPermissions(allAuthorizedPermissions)
                // console.log('Breathe Admin user ',userGroups);
                // const resultantUserGroup = userGroups.find((userGroup)=>userGroup.groupName.includes('BookingAccessGroup'))
                // setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
                // setAuthorizedPermissions({addCouponCode:'false',editCouponCode:'false',deleteCouponCode:'false'})

                // console.log('userGroup permissions : ', JSON.parse(resultantUserGroup.permissions))



            }

        } catch (error) {
            console.error('Error in handling Admin resources authorization', error);

        }
    };

    const formatDate = (dateString) => {
        const dateToConvert = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }

    const convertToTimezone = (dateTimeString, targetZone) => {

        const dateToConvert = new Date(dateTimeString);
        // console.log("timezone ", targetZone);
        // const getDateWithTime = (time) => {
        //     const [hours, minutes, seconds] = time.split(':');
        //     const date = new Date();
        //     date.setUTCHours(hours);
        //     date.setUTCMinutes(minutes);
        //     date.setUTCSeconds(seconds);
        //     return date;
        // };

        const formatTime = (date, timeZone) => {
            return date.toLocaleString('en-US', {
                timeZone: timeZone,
                hour12: true,
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            });
        };
        // console.log('time value : ',dateToConvert)
        // const startTimeDate = getDateWithTime(start);
        // const endTimeDate = getDateWithTime(end);

        // console.log("Start Date Time (UTC):", startTimeDate);
        // console.log("End Date Time (UTC):", endTimeDate);

        const convertedStartTime = formatTime(dateToConvert, targetZone);
        // const convertedEndTime = formatTime(endTimeDate, targetZone);

        // const startTimeInTargetZone = new Date(convertedStartTime);
        // const endTimeInTargetZone = new Date(convertedEndTime);

        return convertedStartTime;
    };



    const getBookings = async (page = 1, pageSize = 10, withoutFilter = false) => {
        setIsLoading(true);
        try {
            // console.log('logging from date and to date: ',filterFromDate,filterToDate);
            const res = await BreathAPIs.getBookingsList(withoutFilter ? { page: 1, limit: 10 } : { page: page, limit: pageSize, filterEmail: filterEmail ? filterEmail : null, filterLocation, filterFromDate, filterToDate, miscFeesValue, bookingStatus, isRefunded });
            setBookings(res.data.bookings);
            setAggregatedBookingStats(res.data.aggregatedBookingStats);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            toast.error('Error fetching bookings.');
        } finally {
            setIsLoading(false);
        }
    };

    const getLocationsData = async () => {
        try {
            setIsLoading((prev) => ({ ...prev, DashboardUptimeData: true }));
            const res = await BreathAPIs.getDashboardFilterLocations()
            setLocationsData(res.data.locations);
        } catch (error) {
            console.log('Error while retrieving locations data', error);
        } finally {
            setIsLoading((prev) => ({ ...prev, DashboardUptimeData: false }));
        }
    }

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getBookings(current, pageSize);
    };

    const handleClearFilter = () => {
        setFilterEmail('');
        setFilterLocation(null);
        setFilterFromDate(null);
        setFilterToDate(null);
        setMiscFeesValue(null);
        setBookingStatus(null);
        setIsRefunded(false);
        setTimezone('localTimezone');
        getBookings(1, 10, true);
    };

    const handleMiscFeeClear = () => {
        setMiscFeesValue(null);
        setIsRefunded(false)
    }


    const columnBookings = [
        {
            title: 'User',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <span> {record.user.name == null ? record.user.firstName + ' ' + record.user.lastName : record.user.name} (<i>{record.user.email}</i>)</span>
            ),
            width: 250
            // fixed: 'left',
        },
        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
            width: 233,
            render: (text, record) => {
                // console.log("record night charging: ", record.isNightCharging, record._id, record)
                return  (
                    <div className={styles['link-text']} onClick={() => showBookingViewModal(record)}>{record._id} {record.isNightCharging && <FaMoon color='#e09839ff' size={15}></FaMoon>}</div>
                )
            }
        },
        {
            title: 'Contact',
            dataIndex: 'phone',
            key: 'phone',
            width: 230,
            render: (text, record) => (
                <span> {record.user.phone ? record.user.phone : 'Not Available'} </span>
            )
        },
        {
            title: 'Modifications',
            dataIndex: '_id',
            key: '_id',
            render: (text, record) => {
                const count = record?.bookingModifications
                    ? record.bookingModifications.filter(mod => mod.type !== 'initiate-now').length
                    : 0;
                return <span>{count}</span>;
            },
            width: 110
        },
        {
            title: 'Start Time',
            dataIndex: 'startTime',
            key: 'startTime',
            render: (text, record) => (
                <span className={(new Date(record.startTime) < new Date()) ? styles['past-date'] : ''}> {
                    timezone === 'localTimezone' ? formatDate(record.startTime) : convertToTimezone(record.startTime, record.charger.location.timezone)
                }</span>
            ),
            width: 200
        },
        {
            title: 'End Time',
            dataIndex: 'endTime',
            key: 'endTime',
            render: (text, record) => (
                <span className={(new Date(record.endTime) < new Date()) ? styles['past-date'] : ''}> {
                    timezone==='localTimezone'?formatDate(record.isNightCharging ? record.endTimeOverNight : record.endTime):convertToTimezone(record.isNightCharging ? record.endTimeOverNight : record.endTime, record.charger.location.timezone)
                    }</span>
            ),
            width: 200
        },
        {
            title: 'Scheduled End Time',
            dataIndex: 'endTimeScheduled',
            key: 'endTimeScheduled',
            render: (text, record) => (
                <span className={(new Date(record.endTimeScheduled) < new Date()) ? styles['past-date'] : ''}> {
                    timezone === 'localTimezone' ? formatDate(record.endTimeScheduled) : convertToTimezone(record.endTimeScheduled, record.charger.location.timezone)
                }</span>
            ),
            width: 200
        },
        {
            title: 'Non Res',
            dataIndex: 'nonReservable',
            key: 'nonReservable',
            render: (text, record) => (
                <span>{record?.nonReservable ? 'Yes' : 'No'}</span>
            ),
            width: 80
        },
        {
            title: 'Charger',
            dataIndex: 'charger',
            key: 'charger',
            render: (text, record) => (
                <span> {record?.charger?.chargerTag} ({record?.sessions?.length} sessions) <br /> <i>{record?.charger?.location.locationName}</i></span>
            ),
            width: 250
        },
        {
            title: <span>Jobs <Button onClick={() => { rescheduleAll() }} type="primary" size="small" style={{ marginLeft: '5px' }}>Reschedule All</Button></span>,
            dataIndex: 'hasBookingJobs',
            key: 'hasBookingJobs',
            width: 200,
            render: (text, record) => (
                <span> {record.hasBookingJobs ? 'Active' : 'No'}</span>
            ),
        },



    ];

    const columnBookingsActionObject = {
        title: '',
        key: 'delete',
        width: 120,
        fixed: 'right',
        render: (text, record) => {
            return (
                <>
                    {
                        <Button type="Text" shape="circle" danger onClick={() => showBookingEditModal(record)}>
                            <AiFillEdit />
                        </Button>

                    }
                    {
                        (userType === 'Admin') ?
                            <Button className='ms-2' shape="circle" danger onClick={() => openDeleteBookingModal(record)}>
                                <AiFillDelete />
                            </Button>
                            :
                            null

                    }
                </>
            );
        }
    }

    const openDeleteBookingModal = (booking) => {
        setBookingToDelete(booking);
        setIsDeleteBookingModalVisible(true);
    };

    const handleDeleteBookingOk = async () => {
        if (bookingToDelete) {
            try {
                setIsDeleting(true);
                await BreathAPIs.cancelBookingAdmin(bookingToDelete._id);
                getBookings();
                toast.success('Booking deleted successfully.');
            } catch (error) {
                console.error('Error deleting booking:', error);

                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors.msg;
                    toast.error(errorMessage);
                } else {
                    toast.error('Error deleting booking. Please try again later.');
                }
            } finally {
                setIsDeleteBookingModalVisible(false);
                setBookingToDelete(null);
                setIsDeleting(false);
                setForceDeleteText('');
            }
        }
    };


    const handleDeleteCancel = () => {
        setIsDeleteBookingModalVisible(false);
        setBookingToDelete(null);
        setForceDeleteText('');
    };

    const handleEditBookingCancel = () => {
        setIsEditBookingModalVisible(false);
        setBookingToEdit(null);
    };

    const showBookingEditModal = (booking) => {
        setIsEditBookingModalVisible(true);
        setBookingToEdit(booking);
    };


    const handleViewBookingCancel = () => {
        setIsViewBookingModalVisible(false);
        setBookingToView(null);
    };

    const showBookingViewModal = (booking) => {
        setIsViewBookingModalVisible(true);
        setBookingToView(booking);
    };

    const rescheduleAll = async () => {
        console.log("reschedule clicked")
        setIsRescheduling(true)
        try {
            const res = await BreathAPIs.rescheduleAllJobs()
            console.log(res.data)
            setReschedulingData(res.data)
        } catch {
            toast.error('Could not Reschedule');
        } finally {
            // setTimeout(() => {
            //     setIsRescheduling(false)
            // }, 5000); 
        }
    }

    const goBack = () => {
        setIsRescheduling(!isRescheduling)
    }

    function convertSecondsToHoursAndMinutes(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const remainingSeconds = totalSeconds % 3600;
        const minutes = Math.floor(remainingSeconds / 60);
        return `${hours} h ${minutes} m`;
    }

    return (
        <>
            {isRescheduling ?
                <div className={`${styles['schedule-container']}`}>
                    <div className={`${styles['schedule-container-sub']}`}>
                        <TerminalLoader reschedulingData={reschedulingData} goBack={goBack}></TerminalLoader>
                    </div>
                </div>
                :

                <Container>
                    <ToastContainer></ToastContainer>


                    <Form layout={'vertical'} >
                        <div className={styles['filter']}>
                            <div className={styles['filter-left']}>
                                <Input value={filterEmail} placeholder='Email: eg:example@email.com' onChange={(e) => setFilterEmail(e.target.value)} />

                                <Select
                                    showSearch
                                    // defaultValue="Select Location"
                                    placeholder={'Select Location'}
                                    style={{ width: '100%' }}
                                    value={filterLocation}
                                    onChange={(value) => { setFilterLocation(value) }}
                                    //onSearch={onSearch}
                                    allowClear
                                    options={locationsData.map(element => ({
                                        value: element._id,
                                        label: element.locationName
                                    }))}
                                    onClear={() => setFilterLocation(null)}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                    }
                                />


                            </div>
                            <div className={styles['filter-right']}>
                                <DatePicker className={styles['datepicker-width']} value={filterFromDate} placeholder='Start Date' onChange={(date) => setFilterFromDate(date)} />
                                <DatePicker className={styles['datepicker-width']} value={filterToDate} placeholder='End Date' onChange={(date) => setFilterToDate(date)} />
                                <Button onClick={() => { getBookings() }} type="primary">Filter</Button>
                                <Button onClick={handleClearFilter} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} />

                            </div>

                        </div>
                        <div className={styles['filter-alt']}>
                            <div
                                className={styles['filter-alt-r1']} >

                                <div
                                    className={styles['select-width']}

                                >
                                    <Select
                                        value={miscFeesValue}
                                        showSearch
                                        onChange={(value) => { setMiscFeesValue(value ?? null) }}
                                        onClear={() => { handleMiscFeeClear() }}
                                        placeholder={'Select Miscellaneous Fees'}
                                        style={{ width: '100%' }}
                                        allowClear
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                        }
                                        options={[{ value: 'unUtilizedFee', label: 'Unutilized Fee' },
                                        { value: 'idleFee', label: 'Idle Fee' },
                                        { value: 'cancellationFee', label: 'Cancellation Fee' },
                                        { value: 'overNightFee', label: 'Overnight Fee/Credit' },
                                        { value: 'miscFee', label: 'Miscellaneous Fee' },
                                        
                                        ]}
                                    />
                                    {/* <Button onClick={()=>{rescheduleAll()}} type="primary">Reschedule All</Button> */}

                                </div>
                                <div
                                    className={styles['select-width']}
                                >
                                    <Select
                                        value={bookingStatus}
                                        showSearch
                                        onChange={(value) => { setBookingStatus(value ?? null) }}
                                        // onClear={() => setBookingStatus(null)}
                                        placeholder={'Select Booking Status'}
                                        style={{ width: '100%' }}
                                        allowClear
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                        }
                                        options={[{ value: 'Upcoming', label: 'Upcoming' },
                                        { value: 'Inprogress', label: 'Inprogress' },
                                        { value: 'Idle', label: 'Idle' },
                                        { value: 'Completed', label: 'Completed' },
                                        { value: 'Cancelled', label: 'Cancelled' },
                                        { value: 'TicketClosed', label: 'TicketClosed' },
                                        { value: 'TimeOut', label: 'TimeOut' },

                                        ]}
                                    />
                                </div>
                            </div>
                            <div
                                className={styles['filter-alt-r2']}
                            >

                                <div
                                    className={styles['select-width']}
                                >
                                    <Select
                                        value={timezone}
                                        showSearch
                                        onChange={(value) => { setTimezone(value) }}
                                        // onClear={() => setTimezone()}
                                        placeholder={'Select Timezone'}
                                        style={{ width: '100%' }}
                                        // allowClear
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                        }
                                        options={[{ value: 'localTimezone', label: 'Local Timezone' },
                                        { value: 'chargerTimezone', label: 'Charger Timezone' },


                                        ]}
                                    />
                                </div>
                                <div
                                    className={styles['select-width']}
                                >
                                    {
                                        (!(miscFeesValue === null))
                                        &&
                                        <>
                                            <span className={styles['refund-switch']} >
                                                {'Refunded'}</span>
                                            <Switch
                                                // disabled={( (miscFeesValue?.length>0))}
                                                checked={isRefunded}
                                                onChange={((value) => { setIsRefunded(value) })}

                                            />
                                        </>
                                    }
                                </div>
                            </div>


{/* 
                            <div
                                className={styles['filter-alt-r3']}
                            >
                                <Button onClick={() => { rescheduleAll() }} type="primary">Reschedule All</Button>
                            </div> */}
                        </div>
                    </Form>

                    <div className={styles.container}>
                        <Row justify="end" gutter={[16, 16]} className={styles.buttonRow}>
                            <Col></Col>
                        </Row>
                    </div>
                    {!isLoading && <div className={styles['aggregated-booking-stats-block']}>
                        <div className={styles['block']}>
                            <div className={styles['head']}>Total number of Bookings</div>
                            <div className={styles['value']}>{aggregatedBookingStats.totalRecords} Nos</div>
                        </div>
                        <div className={styles['block']}>
                            <div className={styles['head']}>Total Utilized Time</div>
                            <div className={styles['value']}>{convertSecondsToHoursAndMinutes(aggregatedBookingStats.totalUtilizedTime)}</div>
                        </div>
                        <div className={styles['block']}>
                            <div className={styles['head']}>Total Unutilized Time</div>
                            <div className={styles['value']}>{convertSecondsToHoursAndMinutes(aggregatedBookingStats.totalUnutilizedTime)}</div>
                        </div>
                        <div className={styles['block']}>
                            <div className={styles['head']}>Total Sessions</div>
                            <div className={styles['value']}>{aggregatedBookingStats.totalSessions} Nos</div>
                        </div>
                    </div>}
                    <Table
                        loading={isLoading}
                        dataSource={bookings}
                        columns={(((JSON.parse(authorizedPermissions?.editBooking || 'false'))

                            && (userType === 'Breathe-Admin')) || (userType === 'Admin')) ? (columnBookings.concat(columnBookingsActionObject)) : columnBookings}
                        rowKey="_id"
                        pagination={pagination}
                        onChange={handleTableChange}
                        className={styles['data-list']}
                        bordered
                        size="middle"
                        scroll={{ x: 'calc(600px + 50%)' }}
                    />
                    <Modal
                        title="Confirm Delete"
                        open={isDeleteBookingModalVisible}
                        onOk={handleDeleteBookingOk}
                        okText={forceDeleteText == 'Delete' ? 'Force Delete' : 'Delete'}
                        onCancel={handleDeleteCancel}
                        confirmLoading={isDeleting}
                    >
                        <div>
                            Are you sure you want to delete {bookingToDelete ? bookingToDelete.bookingTag : ''}
                        </div>
                    </Modal>
                    <EditBooking
                        modalVisible={isEditBookingModalVisible}
                        closeModal={handleEditBookingCancel}
                        selBooking={bookingToEdit}
                        submitFeedback={(message) => { toast.success(message); handleTableChange(pagination); }}
                    />
                    {bookingToView && isViewBookingModalVisible && <ViewBooking
                        modalVisible={isViewBookingModalVisible}
                        closeModal={handleViewBookingCancel}
                        selBooking={bookingToView}
                        setBookingToView={setBookingToView}
                        userType={userType}
                        timezone={timezone}
                        convertToTimezone={convertToTimezone}
                    />}
                    {/* <Modal
            wrapClassName={`${styles['reschedule-modal']}`}
            open={isRescheduling}
            footer={null}
            // style={{ backgroundColor: 'black' }}
            >
                
                <ModalBody className={`${styles['modalContent']}`}>
                    <TerminalLoader></TerminalLoader>
                </ModalBody>
            </Modal> */}
                </Container>}
        </>
    );
};

Bookings.propTypes = {
    booking: PropTypes.string,
    type: PropTypes.string,
};

const mapStateToProps = (state) => ({
    booking: state.auth && state.auth.booking ? state.auth.booking.firstName : null,
    type: state.auth && state.auth.booking ? state.auth.booking.type : null,
    userType: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : null

});

export default connect(mapStateToProps, {})(Bookings);
